var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkull(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M67.719,26.473c-3.394-3.653-8.2-5.748-13.187-5.748H41.468c-4.987,0-9.793,2.095-13.188,5.749 c-3.394,3.654-5.13,8.601-4.764,13.574l1.32,17.925c0.192,2.598,2.382,4.632,4.987,4.632h5.734c0.551,0,1,0.448,1,1v5.542 c0,2.757,2.243,5,5,5h12.885c2.757,0,5-2.243,5-5v-5.542c0-0.552,0.448-1,1-1h5.734c2.604,0,4.795-2.035,4.985-4.632l1.321-17.925 C72.85,35.074,71.113,30.126,67.719,26.473z M68.495,39.753l-1.321,17.925c-0.039,0.52-0.477,0.926-0.997,0.926h-5.734 c-2.757,0-5,2.243-5,5v5.542c0,0.552-0.448,1-1,1h-1.415v-3.633c0-1.104-0.896-2-2-2s-2,0.896-2,2v3.633h-2.055v-3.633 c0-1.104-0.896-2-2-2s-2,0.896-2,2v3.633h-1.415c-0.551,0-1-0.448-1-1v-5.542c0-2.757-2.243-5-5-5h-5.734 c-0.521,0-0.959-0.407-0.998-0.926l-1.32-17.925c-0.29-3.925,1.026-7.674,3.705-10.558s6.321-4.471,10.257-4.471h13.064 c3.936,0,7.577,1.588,10.256,4.471C67.468,32.079,68.783,35.828,68.495,39.753z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.973,52.225c-1.104,0-2,0.896-2,2v3.569c0,1.104,0.896,2,2,2s2-0.896,2-2v-3.569 C46.973,53.12,46.077,52.225,44.973,52.225z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.027,52.225c-1.104,0-2,0.896-2,2v3.569c0,1.104,0.896,2,2,2s2-0.896,2-2v-3.569 C53.027,53.12,52.132,52.225,51.027,52.225z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -20.3358 41.2451)",
    cx: 39.619,
    cy: 45.17,
    rx: 4.778,
    ry: 4.778
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -15.4265 53.0972)",
    cx: 56.381,
    cy: 45.17,
    rx: 4.778,
    ry: 4.778
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkull);
export default __webpack_public_path__ + "static/media/skull.ab60f09271baf84609da5e2bccb00433.svg";
export { ForwardRef as ReactComponent };